import { createAsyncThunk } from '@reduxjs/toolkit';
import type { FetchVaultResponse } from '@syfo/types/adviser.api.types';


/**
 * Fetch a single shared vault by shareId
 * Returns vault data and client metadata
 */
export const fetchVaultThunk = createAsyncThunk<FetchVaultResponse, string>(
  'vault/fetchVault',
  async (shareId: string) => {
    console.log(`[Vault] Fetching vault ${shareId}...`);
    
    const response = await fetch(`/api/vaults/${shareId}`);
    
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Vault not found or access denied');
      }
      throw new Error(`Failed to fetch vault: ${response.status}`);
    }
    
    const data: FetchVaultResponse = await response.json();
    console.log(`[Vault] Fetched vault ${shareId}`);
    return data;
  }
);
